<div [formGroup]="form" class="coupon-generate" hznTestId="coupon-generate">
    <div class="top-bar">
        <div class="modal-title" translate="CouponGenerate.Title"></div>
        <div class="modal-subtitle" translate="">CouponGenerate.Subtitle</div>
    </div>

    <div class="form-group form-horizontal content mb-0">
        <div class="row">
            <div class="col-6">
                <label class="label">{{
                    "CouponGenerate.UsageType" | translate
                }}</label>
                <select formControlName="usageType" class="form-control" hznTestId="coupon-generate-usage-type">
                    @for (c of usageTypeDropdownItems; track c) {
                        <option [ngValue]="c.value">{{ c.displayName }}</option>
                    }
                </select>
            </div>
            @if (isMultiUse()) {
                <div class="col-6">
                    <div class="form-group form-horizontal">
                        <input
                            id="couponCodeRadioManual"
                            type="radio"
                            name="couponCodeProvidedManually"
                            formControlName="couponCodeProvidedManually"
                            [value]="true"
                        />
                        <label
                            class="ml-2"
                            for="couponCodeRadioManual"
                            class="label"
                            >{{
                                "CouponGenerate.CodeManual" | translate
                            }}</label
                        >
                        <input
                            class="ml-2"
                            id="couponCodeRadioAutomatic"
                            type="radio"
                            name="couponCodeProvidedManually"
                            formControlName="couponCodeProvidedManually"
                            [value]="false"
                        />
                        <label
                            class="ml-2"
                            for="couponCodeRadioAutomatic"
                            class="label"
                            >{{
                                "CouponGenerate.CodeAutomatic" | translate
                            }}</label
                        >
                        @if (isCouponCodeManuallyProvided()) {
                            <input
                                class="form-control"
                                formControlName="couponCode"
                                hznTestId="coupon-generate-code"
                                maxlength="100"
                            />
                        }
                    </div>
                </div>
            }
        </div>
        <div class="row mt-2">
            <div class="col-6">
                <label class="label" translate="CouponGenerate.Type"></label>
                <select
                    formControlName="type"
                    hznTestId="coupon-generate-type"
                    class="form-control"
                    [attr.disabled]="null"
                >
                    @for (c of typeDropdownItems; track c) {
                        <option [ngValue]="c.value">{{ c.displayName }}</option>
                    }
                </select>
            </div>

            <div class="col-3">
                <div class="form-group form-horizontal">
                    <label class="label">{{
                        "CouponGenerate.Value" | translate
                    }}</label>

                    @if (isAmount()) {
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">$</span>
                            </div>
                            <input
                                type="text"
                                formControlName="value"
                                hznTestId="coupon-generate-value"
                                [mask]="mask.currencyMask"
                                class="form-control"
                            />
                        </div>
                    }

                    @if (isPercent()) {
                        <div class="input-group">
                            <input
                                type="text"
                                formControlName="value"
                                hznTestId="coupon-generate-value"
                                [mask]="mask.percentValueMask"
                                class="form-control"
                            />
                            <div class="input-group-append">
                                <span class="input-group-text">%</span>
                            </div>
                        </div>
                    }

                    @if (isFreeDays()) {
                        <div class="input-group">
                            <input
                                type="text"
                                formControlName="value"
                                hznTestId="coupon-generate-value"
                                [mask]="mask.daysCountMask"
                                class="form-control"
                            />
                            <div class="input-group-append">
                                <span class="input-group-text">day(s)</span>
                            </div>
                        </div>
                    }
                </div>
            </div>

            @if (isPercent()) {
                <div class="col-3">
                    <div class="form-group form-horizontal">
                        <label class="label">{{
                            "CouponGenerate.MaxAmount" | translate
                        }}</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">$</span>
                            </div>
                            <input
                                type="text"
                                [mask]="mask.currencyMask"
                                formControlName="maxValueLimit"
                                hznTestId="coupon-generate-max-amount"
                                class="form-control"
                            />
                        </div>
                    </div>
                </div>
            }
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group form-horizontal">
                    <label class="label">{{
                        "CouponGenerate.ValidityEnd" | translate
                    }}</label>
                    <bcui-date-picker-input2
                        class="date-picker"
                        formControlName="validityEnd"
                        hznTestId="coupon-generate-validity-end"
                        name="validityEnd"
                    >
                    </bcui-date-picker-input2>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group form-horizontal">
                    <label class="label" translate="CouponGenerate.CouponCategory"
                        ></label
                    >
                    @if (context) {
                        <select
                            formControlName="categoryId"
                            hznTestId="coupon-generate-category"
                            class="form-control"
                            [attr.disabled]="null"
                        >
                            @for (c of context.categories; track c) {
                                <option [ngValue]="c.id">{{ c.name }}</option>
                            }
                        </select>
                    }
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group form-horizontal">
                    <label class="label">{{
                        "CouponGenerate.Reason" | translate
                    }}</label>
                    <textarea
                        rows="5"
                        class="form-control"
                        formControlName="reason"
                        hznTestId="coupon-generate-reason"
                        maxlength="4000"
                    ></textarea>
                </div>
            </div>
        </div>

        @if (!isMultiUse()) {
            <div class="row">
                <div class="col-6">
                    <div class="form-group form-horizontal">
                        <div>
                            <label class="label clickable">{{
                                "CouponGenerate.SendEmail" | translate
                            }}</label>
                        </div>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1"
                                    >&#64;</span
                                >
                            </div>
                            <input
                                type="text"
                                placeholder="{{
                                    'CouponGenerate.EmailPlaceholder'
                                        | translate
                                }}"
                                formControlName="email"
                                hznTestId="coupon-generate-email"
                                class="form-control"
                                aria-describedby="basic-addon1"
                            />
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>

    <div class="form-group form-horizontal right footer mb-0">
        <button class="btn btn-cancel" bcClick (clicked)="cancel()" translate="CouponGenerate.CancelBtn"></button>
        <button
            class="btn btn-success"
            bcClick
            (clicked)="generate()"
            hznTestId="coupon-generate-save"
            translate="CouponGenerate.GenerateBtn"
        ></button>
    </div>
</div>
